import { ElementType } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Dashboard from "../../pages/dashboard/Dashboard";
import ActivePatient from "../../pages/patient/ActivePatient";
import DeactivePatient from "../../pages/patient/DeactivePatient";
import QuickAddPatient from "../../pages/patient/QuickAddPatient";
import FullregisterPatient from "../../pages/patient/FullregisterPatient";
import ClinicManagementPage from "../../pages/setting/bookui/ClinicManagementPage";
import AllBrand from "../../pages/inventory/brand/allBrand/AllBrand";
import AllProduct from "../../pages/inventory/product/allProduct/AllProduct";
import AllCategory from "../../pages/inventory/category/allCategory/AllCategory";
import AllSupplier from "../../pages/inventory/supplier/allSupplier/AllSupplier";
import AddPurchase from "../../pages/inventory/purchase/addPurchase/AddPurchase";
import AllRelease from "../../pages/inventory/productRelease/allRelease/AllRelease";
import AddRelease from "../../pages/inventory/productRelease/addRelease/AddRelease";
import AllPurchase from "../../pages/inventory/purchase/allPurchase/AllPurchase";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import InventoryIcon from "@mui/icons-material/Inventory";
import MyAppointment from "../../pages/myaccount/myappointments/MyAppointment";
import EventIcon from "@mui/icons-material/Event";
import ManagePrint from "../../pages/setting/manageprint/ManagePrint";
import Managetime from "../../pages/setting/managetime/Managetime";
import ManagePurpose from "../../pages/setting/managepurpose/ManagePurpose";
import TreatmentAllList from "../../pages/setting/managetreatment/treatmentlist/TreatmentAllList";
import DeactiveTreatmentList from "../../pages/setting/managetreatment/deactiveTreatmentlist/DeactiveTreatmentList";
import DiagnoseList from "../../pages/setting/managediagnosis/diagnoselist/DiagnoseList";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import Drugs from "../../pages/setting/drugs/Drugs";
import SettingsIcon from "@mui/icons-material/Settings";
import Invoice from "../../pages/payment/invoice/Invoice";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AllLastPayments from "../../pages/payment/payments/allpayments/AllLastPayments";
import ShouldBePaid from "../../pages/payment/payments/shouldbepaid/ShouldBePaid";
import Advanced from "../../pages/payment/payments/advanced/Advanced";
import Completed from "../../pages/payment/payments/completed/Completed";
import AllPaymentList from "../../pages/payment/paymentList/AllPaymentList";
import CommissionReportPage from "../../pages/payment/commission/CommissionReportPage";
import Roles from "../../pages/staff/role/roles/Roles";
import GroupsIcon from "@mui/icons-material/Groups";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AddRole from "../../pages/staff/role/addRole/AddRole";
import DeactiveRole from "../../pages/staff/role/deactiveroles/DeactiveRole";
import Employees from "../../pages/staff/employee/employees/Employees";
import AddEmployee from "../../pages/staff/employee/addemployee/AddEmployee";
import EditEmployee from "../../pages/staff/employee/addemployee/EditEmployee";
import DeactiveEmployee from "../../pages/staff/employee/deactiveEmployee/DeactiveEmployee";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import TreatmentList from "../../pages/treatments/TreatmentList";
import AddTreatment from "../../pages/manage/AddTreatment";
import Diagnose from "../../pages/manage/diagnose/Diagnose";
import TreatmentTable from "../../pages/manage/treatmenttable/TreatmentTable";
import PastTreatment from "../../pages/manage/pasttreatment/PastTreatment";
import Prescription from "../../pages/manage/prescription/Prescription";
import TreatmentPlan from "../../pages/manage/treatmentplan/TreatmentPlan";
import PlannedTreatments from "../../pages/manage/PlannedTreatments";
import AllAppointment from "../../pages/appointment/viewappointment/allAppointment/AllAppointment";
import MakeAppointment from "../../pages/appointment/makeappointment/MakeAppointment";
import YourAppointment from "../../pages/appointment/viewappointment/yourAppointment/YourAppointment";
import PastInvoice from "../../pages/manage/pastinvoice/PastInvoice";
import AllLogs from "../../pages/logs/AllLogs";
import MyLogs from "../../pages/logs/MyLogs";
import DeactveDiagnosis from "../../pages/setting/managediagnosis/diagnoselist/DeactveDiagnosis";
import ScienceIcon from "@mui/icons-material/Science";
import LabPartners from "../../pages/labs/LabPartners";
import SendLabOrder from "../../pages/labs/SendLabOrder";
import ClinicLabOrders from "../../pages/labs/ClinicLabOrders";
type Route = {
  TITLE: string;
  MAINTITLE?: string;
  ICON?: ElementType; // For React component icons
  KEY: number;
  PATH: string;
  DISABLED?: boolean;
  ELEMENT?: ElementType; // For React page components like Dashboard, Employee, etc.
  DIRECT?: boolean;
  SUBNAV?: Route[]; // Recursive for nested menus
  SUBSUBNAV?: Route[]; // Further nesting if needed
};
export const NEWROUTES: Route[] = [
  {
    TITLE: "Dashboard",
    ICON: DashboardIcon,
    KEY: 1,
    PATH: "dashboard",
    ELEMENT: Dashboard,
  },
  {
    TITLE: "Patients",
    ICON: PeopleAltIcon,
    KEY: 2,
    PATH: "patients",
    DIRECT: true,
    SUBNAV: [

      {
        TITLE: "Quick Add",
        ICON: PersonAddIcon,
        KEY: 211,
        PATH: "quick-add",
        ELEMENT: QuickAddPatient,
      },
      {
        TITLE: "Full Registration",
        ICON: PersonAddIcon,
        KEY: 212,
        PATH: "full-registration",
        ELEMENT: FullregisterPatient,
      },
      {
        TITLE: "Patients List",
        ICON: FormatListBulleted,
        KEY: 22,
        PATH: "patients-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "Active",
            KEY: 221,
            PATH: "active",
            ELEMENT: ActivePatient,
          },
          {
            TITLE: "Deactive",
            KEY: 222,
            PATH: "deactive",
            ELEMENT: DeactivePatient,
          },
        ],
      },
      {
        TITLE: "Edit Patient",
        ICON: PeopleAltIcon,
        KEY: 23,
        PATH: "edit-patients/:ID",
        ELEMENT: FullregisterPatient,
        DIRECT: true,
        DISABLED: true,
      },

    ],
  },
  {
    TITLE: "Treatments",
    ICON: MedicalServicesIcon,
    KEY: 3,
    PATH: "treatment-diagnose",
    DIRECT: true,
    DISABLED: true,
    SUBNAV: [
      {
        TITLE: "View Treatments",
        ICON: FormatListBulletedIcon,
        KEY: 31,
        PATH: "view-treatments",
        ELEMENT: TreatmentList,
        DISABLED: true,
        DIRECT: false,
      },
      {
        TITLE: "Treatment",
        ICON: MedicalServicesIcon,
        KEY: 32,
        PATH: "add-treatment",
        DIRECT: true,
        ELEMENT: AddTreatment,
        DISABLED: true,
        SUBNAV: [
          {
            TITLE: "Diagnose",
            KEY: 321,
            PATH: "diagnose/:ID",
            ELEMENT: Diagnose,
          },
          {
            TITLE: "Treatment Table",
            KEY: 322,
            PATH: "treatment-table/:ID",
            ELEMENT: TreatmentTable,
          },
          {
            TITLE: "Past Treatment",
            KEY: 323,
            PATH: "past-treatment/:ID",
            ELEMENT: PastTreatment,
          },
          {
            TITLE: "Prescription",
            KEY: 324,
            PATH: "drugs/:ID",
            ELEMENT: Prescription,
          },
          {
            TITLE: "Planned",
            KEY: 325,
            PATH: "treatment-planned/:ID",
            ELEMENT: PlannedTreatments,
          },
          {
            TITLE: "Treatment Plan",
            KEY: 326,
            PATH: "treatment-plan/:ID",
            ELEMENT: TreatmentPlan,
          },
          {
            TITLE: "Past Invoice",
            KEY: 327,
            PATH: "past-invoice/:ID",
            ELEMENT: PastInvoice,
          },
        ],
      },
    ],
  },
  {
    TITLE: "Payments",
    ICON: ReceiptIcon,
    KEY: 4,
    PATH: "payments",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Create Invoice",
        KEY: 41,
        PATH: "create-invoice",
        ELEMENT: Invoice,
      },
      {
        TITLE: "Invoice",
        KEY: 42,
        PATH: "invoice/:ID",
        ELEMENT: Invoice,
        DISABLED: true,
      },
      {
        TITLE: "Invoices List",
        KEY: 43,
        PATH: "invoices-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Invoices",
            KEY: 431,
            PATH: "all-invoices",
            ELEMENT: AllLastPayments,
          },
          {
            TITLE: "Due Invoices",
            KEY: 432,
            PATH: "due-invoices",
            ELEMENT: ShouldBePaid,
          },
          {
            TITLE: "Advance",
            KEY: 433,
            PATH: "advanced",
            ELEMENT: Advanced,
          },
          {
            TITLE: "Completed",
            KEY: 434,
            PATH: "completed",
            ELEMENT: Completed,
          },
        ],
      },
      {
        TITLE: "Payment List",
        KEY: 44,
        PATH: "payment-list",
        ELEMENT: AllPaymentList,
      },
      {
        TITLE: "Commission Report",
        KEY: 45,
        PATH: "commission-report",
        ELEMENT: CommissionReportPage,
      },
    ],
  },
  {
    TITLE: "Make An Appointment",
    ICON: EventIcon,
    KEY: 6,
    PATH: "appointments",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Make An Appointment",
        ICON: EventIcon,
        KEY: 61,
        PATH: "make-appointment",
        ELEMENT: MakeAppointment,
      },
      {
        TITLE: "Appointments",
        ICON: EventIcon,
        KEY: 62,
        PATH: "view-appointment",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "My Appointment",
            KEY: 621,
            PATH: "my-appointment",
            ELEMENT: YourAppointment,
          },
          {
            TITLE: "All Appointment",
            KEY: 622,
            PATH: "all-appointment",
            ELEMENT: AllAppointment,
          },
        ],
      },
    ],
  },
  {
    TITLE: "My Appointment",
    ICON: EventIcon,
    KEY: 91,
    PATH: "my-appointment",
    ELEMENT: MyAppointment,
  },
  {
    TITLE: "Inventory",
    ICON: InventoryIcon,
    KEY: 8,
    PATH: "inventory",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Category",
        KEY: 81,
        PATH: "category",
        ELEMENT: AllCategory,
      },
      {
        TITLE: "Product",
        KEY: 82,
        PATH: "product",
        ELEMENT: AllProduct,
      },
      {
        TITLE: "Brand",
        KEY: 83,
        PATH: "brand",
        ELEMENT: AllBrand,
      },
      {
        TITLE: "Supplier",
        KEY: 84,
        PATH: "supplier",
        ELEMENT: AllSupplier,
      },

      {
        TITLE: "Purchase",
        KEY: 85,
        PATH: "purchase",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Purchase",
            KEY: 851,
            PATH: "all-purchase",
            ELEMENT: AllPurchase,
          },
          {
            TITLE: "Add Purchase",
            KEY: 852,
            PATH: "add-purchase",
            ELEMENT: AddPurchase,
          },
          {
            TITLE: "Edit Purchase",
            KEY: 853,
            PATH: "edit-purchase/:ID",
            ELEMENT: AddPurchase,
            DISABLED: true,
          },
        ],
      },
      {
        TITLE: "Release",
        KEY: 84,
        PATH: "release",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Release",
            KEY: 841,
            PATH: "all-release",
            ELEMENT: AllRelease,
          },
          {
            TITLE: "Add Release",
            KEY: 842,
            PATH: "add-release",
            ELEMENT: AddRelease,
          },
        ],
      },
    ],
  },
  {
    TITLE: "Clinical settings",
    ICON: SettingsIcon,
    KEY: 7,
    PATH: "clinical-settings",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Manage Time",
        KEY: 71,
        PATH: "manage-time",
        ELEMENT: Managetime,
      },
      {
        TITLE: "Manage Print",
        KEY: 72,
        PATH: "manage-print",
        ELEMENT: ManagePrint,
      },
      {
        TITLE: "Manage Purpose",
        KEY: 73,
        PATH: "manage-purpose",
        ELEMENT: ManagePurpose,
      },
      {
        TITLE: "Treatments & Price List",
        KEY: 74,
        PATH: "treatment-price-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Treatment",
            KEY: 741,
            PATH: "all-treatment",
            ELEMENT: TreatmentAllList,
          },
          {
            TITLE: "Deactive Treatment",
            KEY: 742,
            PATH: "deactive-treatment",
            ELEMENT: DeactiveTreatmentList,
          },
        ],
      },
      {
        TITLE: "Diagnosis List",
        KEY: 75,
        PATH: "diagnosis-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "Active",
            KEY: 751,
            PATH: "active-diagnosis",
            ELEMENT: DiagnoseList,
          },
          {
            TITLE: "Deactive",
            KEY: 752,
            PATH: "deactive-diagnosis",
            ELEMENT: DeactveDiagnosis,
          },
        ],
      },
      {
        TITLE: "Drugs",
        ICON: LocalPharmacyIcon,
        KEY: 76,
        PATH: "drugs",
        ELEMENT: Drugs,
      },
      {
        TITLE: "Booking",
        ICON: BookOnlineIcon,
        KEY: 77,
        PATH: "booktreatment",
        ELEMENT: ClinicManagementPage,
      },
    ],
  },

  {
    TITLE: "Staff",
    ICON: GroupsIcon,
    KEY: 5,
    PATH: "staff",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Employee",
        ICON: GroupsIcon,
        KEY: 52,
        PATH: "employee",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Employees",
            KEY: 521,
            PATH: "all-employees",
            ELEMENT: Employees,
          },

          {
            TITLE: "Deactive Employee",
            KEY: 522,
            PATH: "deactive-employee",
            ELEMENT: DeactiveEmployee,
          },
          {
            TITLE: "Add Employee",
            KEY: 523,
            PATH: "add-employee",
            ELEMENT: AddEmployee,
          },
          {
            TITLE: "Edit Employee",
            KEY: 523,
            PATH: "edit-employee/:ID",
            ELEMENT: EditEmployee,
            DISABLED: true,
          },
        ],
      },
      {
        TITLE: "Role",
        ICON: AdminPanelSettingsIcon,
        KEY: 51,
        PATH: "role",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Roles",
            KEY: 511,
            PATH: "all-role",
            ELEMENT: Roles,
          },
          {
            TITLE: "Deactive Role",
            KEY: 512,
            PATH: "deactive-role",
            ELEMENT: DeactiveRole,
          },
          {
            TITLE: "Add Role",
            KEY: 513,
            PATH: "add-role",
            ELEMENT: AddRole,
          },
          {
            TITLE: "Edit Role",
            KEY: 514,
            PATH: "edit-role/:ID",
            ELEMENT: AddRole,
            DISABLED: true,
          },
        ],
      },

    ],
  },
  {
    TITLE: "Logs",
    ICON: EventIcon,
    KEY: 10,
    PATH: "logs",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "All logs",
        KEY: 101,
        PATH: "all",
        ELEMENT: AllLogs,
      },
      {
        TITLE: "My logs",
        KEY: 102,
        PATH: "my",
        ELEMENT: MyLogs,
      },
    ],
  },
  // {
  //   TITLE: "Dental labs",
  //   ICON: ScienceIcon,
  //   KEY: 11,
  //   PATH: "labs",
  //   DIRECT: true,
  //   SUBNAV: [
  //     {
  //       TITLE: "Partner labs",
  //       KEY: 111,
  //       PATH: "partners",
  //       ELEMENT: LabPartners,
  //     },
  //     {
  //       TITLE: "Send order",
  //       KEY: 112,
  //       PATH: "send-order",
  //       ELEMENT: SendLabOrder,
  //     },
  //     {
  //       TITLE: "Lab orders",
  //       KEY: 113,
  //       PATH: "orders",
  //       ELEMENT: ClinicLabOrders,
  //     },
  //   ],
  // },
];
